import React from 'react';
import useToast from '../../../../../components/Toast';
import { CopyIcon } from '../../../../../utils/svg';
import { formatDate } from '../../../../../utils/helper';
import { OrderStatusList } from '../../../../../utils/constants';
import { useSelector } from 'react-redux';

const DetailTransaction = () => {
	const { showToast } = useToast();
  const { detail } = useSelector((store) => store?.order);

	const copyToClipboard = (text) => {
		navigator.clipboard
			.writeText(text)
			.then(() => {
				console.log('copy', text);
				showToast('info', 'copied');
			})
			.catch((err) => {
				console.error('Failed to copy: ', err);
			});
	};

	const status = OrderStatusList?.[detail?.orderStatus];

	return (
		<div className='my-5'>
			<h2 className='text-sm font-semibold'>Detail Transaksi</h2>
			<div className='flex justify-between mt-4'>
				<p className='text-xs font-normal'>Nomor Pesanan</p>
				<div className='flex gap-2'>
					<div className='flex items-center cursor-pointer' onClick={() => copyToClipboard(detail?.orderNumber)} id='detail_order_copy_number'>
						<p className='text-xs font-semibold text-gray-900 pr-2'>{detail?.orderNumber}</p>
						<CopyIcon className='stroke-[var(--rose-violet)]' />
					</div>
				</div>
			</div>
			<div className='flex justify-between mt-2'>
				<p className='text-xs font-normal'>Waktu Pembelian</p>
				<p className='text-xs font-semibold text-gray-900'>{formatDate(detail?.order_date || detail?.created_at, 'D MMM YYYY, HH:mm A')}</p>
			</div>
			<div className='flex justify-between mt-2'>
				<p className='text-xs font-normal'>Status</p>
				<div className='text-xs font-semibold'>
					<div className={status?.className}>{status?.message}</div>
				</div>
			</div>
		</div>
	);
};

export default DetailTransaction;
